import { Button } from "@/components/ui/button";

interface SpotDeleteDialogProps {
  spotName: string;
  onCancel: () => void;
  onConfirm: () => void;
  deleting: boolean;
}

export default function SpotDeleteDialog({ spotName, onCancel, onConfirm, deleting }: SpotDeleteDialogProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-foreground/40" onClick={onCancel} />
      <div className="relative bg-card border border-border rounded-xl shadow-xl w-full max-w-sm mx-4 p-6 space-y-4">
        <h3 className="font-bold text-foreground text-lg">Delete {spotName}?</h3>
        <p className="text-sm text-muted-foreground">
          This can be undone by re-activating the spot.
        </p>
        <div className="flex items-center justify-end gap-2 pt-2">
          <Button variant="ghost" onClick={onCancel} disabled={deleting}>Cancel</Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={deleting}
          >
            {deleting ? "Deleting…" : "Delete"}
          </Button>
        </div>
      </div>
    </div>
  );
}
